module.exports = __webpack_public_path__ + "img/fastcharger-in-progress.c8862679.svg";